<template>

  <div class="comment">
    <div class="comment_title">全部评论({{commentsCount.total}})</div>
    <div class="comment_type">
      <el-button size="mini" type='danger' @click='()=>initComments(1)' >
        <span class="comment_type_button_text">很好 {{commentsCount.goodCount}}</span>
      </el-button>
      <el-button size="mini" type='danger' @click='()=>initComments(2)' class="comment_type_button">
        <span class="comment_type_button_text">好 {{commentsCount.mediumCount}}</span>
      </el-button>
      <el-button size="mini" type='danger' @click='()=>initComments(3)' class="comment_type_button">
        <span class="comment_type_button_text">一般 {{commentsCount.badCount}}</span>
      </el-button>
    </div>  
    <div v-if="comments&&comments.length" class="commentLists">
      <!-- <ul class="infinite-list" style="overflow:auto"> -->
        <!-- <li v-for="(item,index) in comments" key ="index" class="infinite-list-item"> -->
        <div class='commentItem' v-for="(item,index) in comments" :key ="index">
          <div class="comments_title">
            <div class="comments_title_left">
              <el-image
                fit='cover'
                class="commentUserImg"
                :src="item.headImg?getImageUrl(item.headImg):'https://timgsa.baidu.com/timg?image&quality=80&size=b9999_10000&sec=1573893164231&di=439fd9e8daceb71cad9c062cdc0cbf3c&imgtype=0&src=http%3A%2F%2Fhbimg.b0.upaiyun.com%2F69ad7a731f43d4b8729f1a2fbe65c43801ca0f033250-EV1vMf_fw658'"
              ></el-image>
              <span>{{item.nickName}}</span>
            </div>
            <div>{{item.createTime.split(' ')[0]}}</div>
          </div>
          <div>
            <div class="item_content">{{item.content}}</div>
          </div>
        </div>
      <!-- </ul> -->
    </div>
    <div class='noMore' v-else>
      <i class='el-icon-tickets'> 暂无评论</i>
    </div>
  </div>
</template>

<script>
import { getEvaluateMsgListUrl, getImageUrl } from "@/api/api";

export default {
  props: ["goodsId"],
  data() {
    return {
      id: "",
      index: 0,
      pageSize: 30,
      commentsCount: "",
      comments: null
    };
  },
  watch: {
    goodsId(val) {
      this.id = val;
    }
  },
  methods: {
    load() {
      this.index++;
    },
    initComments(type) {

        let url = getEvaluateMsgListUrl;
        let data = {
          gid: this.goodsId,
          pageIndex: this.index,
          pageSize: this.pageSize,
          type:type||1
        };

        let param = new URLSearchParams();
        for (var k in data) {
          param.append(k, data[k]);
        }
        this.$axios({
          method: "post",
          data: param,
          url
        })
          .then(res => {
            console.log(res);
            if (res.data.resultCode == 1) {
              this.commentsCount = res.data.count;
              this.comments = res.data.data;
            } else {
              this.$alert({
                title: "标题",
                message: res.data.resultMsg
              });
            }
          })
          .catch(err => {
            this.$alert({
              title: "标题",
              message: err.msg || err.message || err.resultMsg
            });
          });
      
    }
  },
  mounted() {
    // alert(1)
    this.initComments();
    this.getImageUrl = getImageUrl;
  }
};
</script>

<style lang='less' scoped>
.comment{
  min-height: 500px;
  width: 100%;
}
.commentUserImg{
  width: 40px;
  height:40px;
  border-radius: 40px;
  margin-right: 10px;
}
.comments_title_left{
  display: flex;
  align-items: center
}
.comments_title{
  width: 500px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  color:#666;
}
.item_content{
  margin: 10px 50px;

}
.commentItem{
  margin: 5px 0;
}
.commentLists{
  padding: 10px;
}
.comment_type{
  margin-top: 10px;
}
.noMore{
  margin-top: 100px;
  text-align: center;
  font-size: 16px;
  color:#aaa
}
</style>



// WEBPACK FOOTER //
// src/components/GoodsDetail/component/Comments.vue